import firebase from "firebase/compat/app";
import "firebase/compat/messaging";
import { FCMVapidKey } from "~/enums";
import { sentFCMToken } from "./notification";

const firebaseConfig = {
  apiKey: "AIzaSyAf2wCV5q423hgr894ssdf_qHtBDpv-Ky8",
  authDomain: "smart-wallet-d44e4.firebaseapp.com",
  projectId: "smart-wallet-d44e4",
  storageBucket: "smart-wallet-d44e4.appspot.com",
  messagingSenderId: "270310215533",
  appId: "1:270310215533:web:c88242f3e1d7445df89464",
  measurementId: "G-GTG551LN67",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging and get a reference to the service
export const messaging = firebase.messaging();

const requestNotificationsPermissions = async () => {
  const permission = await Notification.requestPermission();

  if (permission === "granted") {
    getFCMToken();
  } else {
    console.log("Unable to get permission to notify.");
  }
};

export const getFCMToken = async () => {
  // get valid time from local storage
  const {
    storedToken,
    validTime,
  }: { storedToken?: string; validTime?: string } = JSON.parse(
    localStorage.getItem("fcm-token") || "{}"
  );

  const today = new Date();

  // check if do not have token or stored token is invalided
  if (
    !storedToken ||
    (storedToken && today.getTime() >= new Date(validTime || "").getTime())
  ) {
    try {
      const token = await messaging.getToken({ vapidKey: FCMVapidKey });

      if (token) {
        console.log("FCM token:", token);

        // save token to storage
        const newValidTime = new Date();
        newValidTime.setDate(newValidTime.getDate() + 10);

        localStorage.setItem(
          "fcm-token",
          JSON.stringify({
            storedToken: token,
            validTime: newValidTime,
          })
        );

        // sent token for backend
        sentFCMToken(token, newValidTime.toISOString());

        return token;
      } else {
        requestNotificationsPermissions();
      }
    } catch (error) {
      console.error("Unable to get messaging token.", error);
    }
  }
};
